<div class="hq-form-layout__info-tool-{{ typeInfo }}">
    <span class="hq-form-layout__info-tool-icon" pTooltip="{{ message }}" *ngIf="message">
        <span class="{{ icon }}"></span>
    </span>

    <span class="hq-form-layout__info-tool-empty" *ngIf="!message">
        <span class="{{ icon }}"></span>
    </span>
</div>
